import { render, staticRenderFns } from "./designPrototype.vue?vue&type=template&id=02bd0b97&"
import script from "./designPrototype.vue?vue&type=script&lang=js&"
export * from "./designPrototype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports